import { render, staticRenderFns } from "./AppointmentItemInfo.vue?vue&type=template&id=4dd3db98&"
import script from "./AppointmentItemInfo.vue?vue&type=script&lang=js&"
export * from "./AppointmentItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentItemInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports